import { getFromPSApi } from 'actions';
import config from '../../config';

export default resourcePath =>
  getFromPSApi(config.preferencesService.baseUrl, resourcePath);
